import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { $t } from "@/lib/i18nHelpers";
import {
  formatMoneyString as formatMoneyStringLib,
  formatMoney as formatMoneyLib,
  setCreditCurrencyEqlCode,
} from "@scrile/tools/dist/lib/MoneyHelpers";
export { getCurrencySymbol } from "@scrile/tools/dist/lib/MoneyHelpers";
import store from "@/store";
import { getLocale } from "@/lib/localeHelper";
import config from "@/config";

export function getMainCurrencyCode() {
  const code = store.state.systemSettings?.mainCurrency ?? "USD";
  setCreditCurrencyEqlCode(code);
  return code;
}

interface FormatMoneyOpts {
  currencyCode?: string;
  forceNumberSymbol?: boolean;
}

export function formatMoney(amount: number, { currencyCode, forceNumberSymbol = false }: FormatMoneyOpts = {}) {
  return formatMoneyLib(amount, {
    currencyCode: currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
  });
}

export function formatMoneyString(amount: number, { currencyCode, forceNumberSymbol = false }: FormatMoneyOpts = {}) {
  return formatMoneyStringLib(amount, {
    currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
  });
}

export function getCost(pricePackage: PaymentPackage): number {
  return pricePackage.amount;
}

export function getCurrentPaymentSystem(systems: PaymentSystemPublic[], currency: string) {
  const system = systems.find(publicSystem => publicSystem.currencies.includes(currency));
  if (!system) throw new Error("System not found");
  return system;
}

export function getShrinkedNumber(value: number): string {
  if (value > 999999) return `${Math.floor(value / 1000000)}M`;
  if (value > 999) return `${Math.floor(value / 1000)}K`;
  return `${value}`;
}

export function printPaymentPackageName(name: string) {
  return name ? `${name}, ` : "";
}

export function printPaymentPackage(paymentPackage: PaymentPackage) {
  return `${printPaymentPackageName(paymentPackage.name)}${formatMoneyString(paymentPackage.amount)}`;
}

export function getCostByCurrency(p: PaymentPackage, currency: string = getMainCurrencyCode()) {
  return p.costs.find(i => i.currency === currency);
}

export function isCryptoSystem(systemName: string) {
  return systemName.endsWith("_p2p");
}
